import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import '../plugins/jquery.gm';

const fragments = {
	MAP: '[data-fragment="GoogleMap.map"]',
	SHOW_MAP: '[data-fragment="GoogleMap.show"]',
	CHOICE_BEER: '[data-fragment="GoogleMap.choiceBeer"] select',
	CHOICE_CERTIFICATION: '[data-fragment="GoogleMap.choiceCertification"] select',
	CHOICE_CATEGORY: '[data-fragment="GoogleMap.choiceCategory"]',
	SEARCH_INPUT: '[data-fragment="GoogleMap.searchInput"]',
	SEARCH_SUBMIT: '[data-fragment="GoogleMap.searchSubmit"]',
}

class GoogleMap extends WebComponent {
	constructor(props) {
		super(props);

		this.showMap = this.showMap.bind(this);
	}

	didMount() {
		this.searchInput = this.element.querySelector(fragments.SEARCH_INPUT);
		this.choiceBeer = this.element.querySelector(fragments.CHOICE_BEER);
		this.choiceCertification = this.element.querySelector(fragments.CHOICE_CERTIFICATION);
		this.choiceCategory = this.element.querySelectorAll(fragments.CHOICE_CATEGORY);
		this.mapEl = this.element.querySelector(fragments.MAP);
		this.map = $(this.mapEl);
		this.choiceCategoryValue = null;
		this.choiceBeerValue = null;
		this.choiceCertificationValue = null;
		this.searchSubmitElement = this.element.querySelector(fragments.SEARCH_SUBMIT);
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		this.certificationPub = urlParams.get('certification');
		if(this.certificationPub) {
			this.showMap();
			const certificationValue = this.choiceCertification.querySelector('option[value="certification"]');
			if(certificationValue) {
				certificationValue.selected = true;
				this.choiceCertification.dispatchEvent(new Event('change'));
			}
		}
		this.showMarker = urlParams.get('marker');
		if(this.showMarker){
			this.showMap();
		} else {
			this.on('click', fragments.SHOW_MAP, this.showMap);
		}
		this.on('click', fragments.SEARCH_SUBMIT, this.handleClickOnSearchSubmit);
		this.on('change', fragments.CHOICE_BEER, this.handleChangeBeer);
		this.on('change', fragments.CHOICE_CERTIFICATION, this.handleChangeCertification);
		this.on('click', fragments.CHOICE_CATEGORY, this.handleChangeCategory);

		this.xhrCount = 0;
		this.mapData = {};
		this.mapDataPos = {};

		this.choiceBeerVisibility();
	}

	showMap = () => {
		if(!this.element.classList.contains('pub-map--searched')) {
			this.element.classList.add('pub-map--searched');
			this.element.classList.add('pub-map--loading');
			this.choiceCertification.parentElement.classList.remove('hidden');
			this.initGoogleMap();
		} else {
			return true;
		}
		return false;
	}

	handleClickOnSearchSubmit = (e) => {
		e.preventDefault();
		if(this.showMap()) {
			this.FilterMap.doSearch();
		}
	}

	handleChangeBeer = () => {
		this.choiceBeerValue = this.choiceBeer.value;
		if(this.showMap()) {
			this.FilterMap.doFilter();
		}
	}

	handleChangeCertification = () => {
		this.choiceCertificationValue = this.choiceCertification.value;
		if(this.showMap()) {
			this.FilterMap.doFilter();
		}
	}

	handleChangeCategory = (e) => {
	    this.scrollToMapElement();
		if(this.showMap()) {
			if (this.choiceCategoryValue === e.target.value) {
				/* unselect */
				this.choiceCategory[0].click();
			} else {
				this.choiceCategoryValue = e.target.value;
				this.FilterMap.doFilter();
			}
		} else {
			this.choiceCategoryValue = e.target.value;
		}
		this.choiceBeerVisibility();
	}

	choiceBeerVisibility = () => {
		if (this.choiceCategoryValue === '3') {
			this.choiceBeer.parentElement.classList.remove('hidden');
		} else {
			this.choiceBeer.parentElement.classList.add('hidden');
		}
	}

	scrollToMapElement = () => {
		let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		let offset = 200
		if (windowWidth < 1200) {
			offset = 280;
		}
		if (windowWidth < 768) {
			offset = 120;
		}
		const bodyRect = document.body.getBoundingClientRect().top;
		const elementRect = this.mapEl.getBoundingClientRect().top;
		const elementPosition = elementRect - bodyRect;
		const offsetPosition = elementPosition - offset;
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	}

	initCenterAndZoom = () => {
		this.map.googlemap('setCenterAndZoom',{
			lat: 49.575146,
			lng: 17.640001,
			zoom: 7,
		});
	}

	initGoogleMapToDefault = () => {
		this.map.googlemap('filterObjects', 'markers', null, null, null);
		this.initCenterAndZoom();
	}

	initGoogleMap = () => {
		let ZNPPhotos = {
			"breclav@bernard.cz":			"/img/maps/znp/breclav-01.jpg",
			"valasskemezirici@bernard.cz":	"/img/maps/znp/valasske-mezirici-01.jpg",
			"humpolec@bernard.cz":			"/img/maps/znp/humpolec-02.jpg",
			"tabor@bernard.cz":				"/img/maps/znp/tabor-02.jpg",
			"trebic@bernard.cz":			"/img/maps/znp/trebic-01.jpg",
			"kolin@bernard.cz":				"/img/maps/znp/kolin-02.jpg",
			"opava@bernard.cz":				"/img/maps/znp/opava-02.jpg",
			"prostejov@bernard.cz":			"/img/maps/znp/prostejov-02.jpg",
			"ricany@bernard.cz":			"/img/maps/znp/ricany-01.jpg",
			"zlin@bernard.cz": 				"/img/maps/znp/zlin-01.jpg",
		};
		$.googlemap.setDefaults({
			lang: $('html').attr('lang'),
			messages: {
				cs: {
					telReservation : "Rezervace",
					pubType: "Typ zařízení",
					pubSeason: "Sezóna",
					openingHours : "Otevírací doba",
					openingHoursCommon: "Po - Pá",
					openingHoursWeekend: "So",
					distance: "Vzdálenost: ",
					distance2: " km",
					certification: 'Certifikovaná hospoda'
				},
				en: {
					telReservation : "Reservation",
					pubType: "Type",
					pubSeason: "Season",
					openingHours : "Opening hours",
					openingHoursCommon: "Mo - Fr",
					openingHoursWeekend: "Sa",
					distance: "Distance: ",
					distance2: " km",
					certification: 'Certified pub'
				}
			},
			mapOptions: {
				startingPosition: {    //přerov vycentrovani mapy pro zobrazeni cs i sk
					lat: 49.575146,
					lng: 17.640001,
					zoom: 7,
				},
				minZoom: 3,
				mapTypeControl: false,
				scaleControl: false,
				panControl: true,
				streetViewControl: false,
				styles: [
					{
						"featureType": "all",
						"elementType": "geometry.fill",
						"stylers": [
							{
								"weight": "2.00"
							}
						]
					},
					{
						"featureType": "all",
						"elementType": "geometry.stroke",
						"stylers": [
							{
								"color": "#9c9c9c"
							}
						]
					},
					{
						"featureType": "all",
						"elementType": "labels.text",
						"stylers": [
							{
								"visibility": "on"
							}
						]
					},
					{
						"featureType": "landscape",
						"elementType": "all",
						"stylers": [
							{
								"color": "#f2f2f2"
							}
						]
					},
					{
						"featureType": "landscape",
						"elementType": "geometry.fill",
						"stylers": [
							{
								"color": "#ffffff"
							}
						]
					},
					{
						"featureType": "landscape.man_made",
						"elementType": "geometry.fill",
						"stylers": [
							{
								"color": "#ffffff"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "all",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "all",
						"stylers": [
							{
								"saturation": -100
							},
							{
								"lightness": 45
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "geometry.fill",
						"stylers": [
							{
								"color": "#eeeeee"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#7b7b7b"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "labels.text.stroke",
						"stylers": [
							{
								"color": "#ffffff"
							}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "all",
						"stylers": [
							{
								"visibility": "simplified"
							}
						]
					},
					{
						"featureType": "road.arterial",
						"elementType": "labels.icon",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "transit",
						"elementType": "all",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "all",
						"stylers": [
							{
								"color": "#46bcec"
							},
							{
								"visibility": "on"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "geometry.fill",
						"stylers": [
							{
								"color": "#c8d7d4"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#070707"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "labels.text.stroke",
						"stylers": [
							{
								"color": "#ffffff"
							}
						]
					}
				]
			},
			clustering: {
				enabled: true,
				iconsStyles: [
					{
						textColor: '#fff',							// color of the number on the groupped marker
						url: '/img/maps/marker-cluster-restaurace-a-hospody.png',		// self-explanatory
						height: 72,									// height of the groupped marker
						width: 72,									// width of the groupped marker
						textSize: 20								// font size of the number
					}
				],
				maxZoom: 12
			},
			markerTypes: [

				// 0
				{},
				// 1
				{
					icon: {
						url: '/img/maps/marker-znackove-prodejny.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 2
				{
					icon: {
						url: '/img/maps/marker-velkoobchody.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 3
				{
					icon: {
						url: '/img/maps/marker-obchody.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 4
				{
					icon: {
						url: '/img/maps/marker-restaurace-a-hospody.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 5
				{
					icon: {
						url: '/img/maps/marker-puby-a-bary.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 6
				{
					icon: {
						url: '/img/maps/marker-puby.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 7
				{},
				// 8
				{},
				// 9
				{},
				// 10
				{},
				// prefix 1 + pointType - pro certifikovane zobrazeni markeru
				// 11
				{
					icon: {
						url: '/img/maps/marker-certification-znackove-prodejny.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 12
				{
					icon: {
						url: '/img/maps/marker-certification-velkoobchody.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 13
				{
					icon: {
						url: '/img/maps/marker-certification-obchody.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 14
				{
					icon: {
						url: '/img/maps/marker-certification-restaurace-a-hospody.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 15
				{
					icon: {
						url: '/img/maps/marker-certification-puby-a-bary.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
				// 16
				{
					icon: {
						url: '/img/maps/marker-certification-puby.png',
						size: new google.maps.Size(32, 32),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 32)
					},
					shape: {
						coords: [0, 0, 32, 32],
						type: 'rect'
					}
				},
			],
			bubbleContentFormatter: function(mData) {
				var str = '';
				var pubMapBubbleClass = (mData.type === 1) ? ' pub-map-bubble--znp' : '';
				var phoneLink = '<a href="tel:'+mData.phone+'">'+ mData.phone+'</a>'
				var emailLink = '<a href="mailto:'+mData.email+'">'+ mData.email+'</a>'
				str += '<div class="pub-map-bubble'+pubMapBubbleClass+'">';
				if (mData.title) { str += '<h3 class="pub-map-bubble__title">'+mData.title+'</h3>'; }
				if (mData.filter.certification && mData.filter.certification.includes('1')) {
					str += '<div data-is="Tooltip" data-tippy-content="Více se dozvíte zde." data-theme="pubMap" title="">';
					str +=		'<a href="/cs/certifikovana-hospoda"  class="pub-map-bubble__certification">'+eval('this.messages.' + this.lang + '.certification')+'</a>';
					str += '</div>';
				}

				if (mData.city) {
					str += '<address>';
					if (mData.email && ZNPPhotos[mData.email]) {
						str += '<div class="pub-map-bubble__motive" style="background-image: url('+ZNPPhotos[mData.email]+');"></div>';
					}
					if (mData.street) {
						str += mData.street+ '<br />';
					}
					str += mData.city;
					if (mData.zip) {
						str += '<br />' +  mData.zip;
					}
					str += '</address>';
				}
				if (mData.phone || mData.gsm || mData.email || (mData.web && (mData.type === 1 || mData.type === 4 || mData.type === 6))) {
					str += '<table><tbody>';
					if (mData.phone && mData.type < 4) { str += '<tr><td><strong>Tel.:</strong></td><td>' + phoneLink + '</td></tr>'; }
					if (mData.phone && mData.type > 3) { str += '<tr><td><strong>'+eval('this.messages.' + this.lang + '.telReservation')+':</strong></td><td>' + phoneLink + '</td></tr>'; }
					if (mData.gsm) { str += '<tr><td><strong>GSM:</strong></td><td>'+mData.gsm+'</td></tr>'; }

					if (mData.email) {
						str += '<tr><td><strong>E-mail:</strong></td><td>' + emailLink + '</td></tr>';
					}
					if (mData.type > 1) {
						if (mData.web) { str += '<tr><td><strong>Web:</strong></td><td> <a target="_blank" rel="noopener noreferrer" href="http://'+mData.web.replace("http://","")+'">' + mData.web + '</a></td></tr>'; }
					}
					if (mData.type > 3) {
						if (mData.description) { str += '<tr><td><strong>'+eval('this.messages.' + this.lang + '.pubType')+':</strong></td><td>' + mData.description + '</td></tr>'; }
						if (mData.season) { str += '<tr><td><strong>'+eval('this.messages.' + this.lang + '.pubSeason')+':</strong></td><td>' + mData.season + '</td></tr>'; }
					}
					str += '</tbody></table>';
				}


				if (mData.type === 1) {
					str += '<h4 class="pub-map-bubble__title">'+eval('this.messages.' + this.lang + '.openingHours')+'</h4>';
					str += '<table><tbody>';
					str += '	<tr><td>';
					str += '		<strong>'+eval('this.messages.' + this.lang + '.openingHoursCommon')+':</strong></td><td>';
					if (mData.oteviraciDobaPoPaDopo && mData.oteviraciDobaPoPaDopo.length > 0) { str += '		<em>'+mData.oteviraciDobaPoPaDopo+'</em>'; }
					if (mData.oteviraciDobaPoPaOdpo && mData.oteviraciDobaPoPaOdpo.length > 0) { str += '		<em>'+mData.oteviraciDobaPoPaOdpo+'</em>'; }
					str += '	</td></tr>';
					str += '	<tr><td>';
					str += '		<strong>'+eval('this.messages.' + this.lang + '.openingHoursWeekend')+':</strong></td><td>';
					if (mData.oteviraciDobaSo && mData.oteviraciDobaSo.length > 0) { str += '		<em>'+mData.oteviraciDobaSo+'</em>'; }
					if (mData.oteviraciDobaSoOdpo && mData.oteviraciDobaSoOdpo.length > 0) { str += '		<em>'+mData.oteviraciDobaSoOdpo+'</em>'; }
					str += '	</td></tr>';
					str += '</tbody></table>';
				}

				// if (mData.type === 3) {
				//
				// 		str += '<p class="pub-map-bubble__gmap-report">'+eval('this.messages.' + this.lang + '.gmTitle1') +
				// 				'<br/><button class="btn btn--secondary btn--sm js_esp-trigger" data-esp-target="/qf/'+this.lang+'/ramjet/gmapsReport/gmapsReportForm@pageContainer?posId='+mData.id+'" data-esp-trigger-event="click" data-esp-content-type="ajaxScript" data-esp-type="fixed">'+eval('this.messages.' + this.lang + '.gmTitle2')+'</button></p>';
				// }
				str += '</div>';
				return str;

			}
		})

		this.map.googlemap();

		let _self = this;
		let url = this.element.dataset.url;
		let urlPos = this.element.dataset["url-1"];

		const xhr = new XMLHttpRequest();
		xhr.open('GET', url, true);
		xhr.overrideMimeType("application/json");
		xhr.onload = function () {
			_self.mapData = this.responseText;
			_self.loadMarkersData();

		}
		xhr.send(null);

		const xhrPos = new XMLHttpRequest();
		xhrPos.open('GET', urlPos, true);
		xhrPos.overrideMimeType("application/json");
		xhrPos.onload = function () {
			_self.mapDataPos = this.responseText;
			_self.loadMarkersData();

		}
		xhrPos.send(null);


		var myFilterTimeout;
		_self.FilterMap = {
			doSearch: function () {
				let searchValue = _self.searchInput.value;
				let filters = this.getFilters();
				let bounds = new google.maps.LatLngBounds();
				_self.map.googlemap('filterObjects', 'markers', filters.categoryFilter, {search: [searchValue]}, {
					onMarkerSuccess: function (marker) {
						bounds.extend(marker.position);
						clearTimeout(myFilterTimeout);
						myFilterTimeout = setTimeout(function () {
							_self.map.googlemap('zoomToMarkersBoundsCustom', bounds, marker);
						 },200);
					},
					fulltextType: 'places'
				});
			},
			doFilter: function () {
				let searchValue = _self.searchInput.value;
				let filters = this.getFilters();
				let bounds = new google.maps.LatLngBounds();
				if(((filters.categoryFilter.beer.length + filters.categoryFilter.category.length + filters.categoryFilter.certification.length) > 0) || searchValue !== '') {
					_self.map.googlemap('filterObjects', 'markers', filters.categoryFilter, {search: [searchValue]}, {
						onMarkerSuccess: function (marker) {
							bounds.extend(marker.position);
							clearTimeout(myFilterTimeout);
							myFilterTimeout = setTimeout(function () {
								if(filters.categoryFilter.category.includes("4")) {
									_self.initCenterAndZoom();
								} else {
									_self.map.googlemap('zoomToMarkersBoundsCustom', bounds, marker);
								}
							},200);
						},
						fulltextType: 'places'
					});
				}
				if(filters.categoryFilter.category.length === 0 && filters.categoryFilter.certification.length === 0 && searchValue === '') {
					_self.initGoogleMapToDefault();
				}
			},
			doShowMarker: function () {
				let bounds = new google.maps.LatLngBounds();
				_self.map.googlemap('filterObjectsShowMarker', 'markers', _self.showMarker, {
					onMarkerSuccess: function(marker) {
						bounds.extend(marker.position);
						clearTimeout(myFilterTimeout);
						myFilterTimeout = setTimeout(function () {
							_self.map.googlemap('zoomToMarkersBoundsCustom', bounds, marker);
						},200);
					}
				});
			},
			getFilters: function () {
				let beerValue = [], categoryValue = [], certificationValue = [];
				if(_self.choiceBeerValue) {
					if(_self.choiceCategoryValue === '3') {
						beerValue.push(_self.choiceBeerValue);
					}
				}
				if((_self.choiceCertificationValue && _self.choiceCertificationValue === 'certification') || (_self.certificationPub && _self.certificationPub === '1')) {
					certificationValue.push("1");
				}

				if(_self.choiceCategoryValue) {
					let categoryValueSplit = _self.choiceCategoryValue.split(",");
					categoryValueSplit.forEach(value => {
						categoryValue.push(value);
					})
				}
				return {
					categoryFilter: {beer: beerValue, category: categoryValue, certification: certificationValue}
				}
			}
		}


		window.google.maps._$map = this.map;

	}

	loadMarkersData = () => {
		let _self = this;
		this.xhrCount++;

		if(this.xhrCount === 2) {
			let mapDataAll = JSON.parse('['+this.mapData + ',' + this.mapDataPos+']');
			this.map.googlemap('loadMarkers', {
				data: mapDataAll,
				listeners: {
					click: function (ev, data, marker) {
						// this.setCenterAndZoom({
						// 	lat: marker.getPosition().lat(),
						// 	lng: marker.getPosition().lng(),
						// 	position: [0.5, 0.8]
						// });
						return true;
					}
				},
				callback: function () {
					_self.mapLoading('remove');
					let filters = _self.FilterMap.getFilters();
					if(_self.searchInput.value !== '') {
						_self.FilterMap.doSearch();

					} else if((filters.categoryFilter.beer.length + filters.categoryFilter.category.length + filters.categoryFilter.certification.length) > 0) {
						_self.FilterMap.doFilter();
					}
					if(parseInt(_self.showMarker) > 0){
						_self.FilterMap.doShowMarker();
					}
					if(parseInt(_self.certificationPub) > 0) {
						_self.choiceCategory[_self.certificationPub].click();
					}
				}
			});
		}
	}

	mapLoading = (state) => {
		if(state === 'remove') {
			setTimeout(()=> {
				this.element.classList.remove('pub-map--loading');
			},250);
		}
	}
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoogleMap.js